import { defAlias, defBaseUnit, defSimpleUnit } from '../registry';

export const powerUnits = [
  // Power
  defBaseUnit('watt', 'kg-m^2/s^3'),
  defSimpleUnit('milliwatt', 'watt', 1e-3),
  defSimpleUnit('kilowatt', 'watt', 1e3),
  defSimpleUnit('megawatt', 'watt', 1e6),
  defSimpleUnit('gigawatt', 'watt', 1e9),
  defSimpleUnit('terawatt', 'watt', 1e12),

  // US/UK customary units
  defSimpleUnit('horsepower', 'watt', 745.69987158227022),
];

defAlias('kw', 'kilowatt');
